const defaultState = {
  companyImage: null,
  companyImageUrl: null,
  name: '',
  shortName: '',
  mainDomain: '',
  email: '',
  phone: '',
  street: '',
  city: '',
  postCode: '',
  vatNumber: '',
  regon: '',
  mainColor: '#000000',
  defaultConfigFromBrand: '',
  loadAllVariantsInitially: false,
  dishIngredientsDecimalPlaces: 2,
  showFooterCaterings: false,
  maxDishesToProducePerDayEnabled: false,
  maxDishesToProducePerDay: 0,
  maxDishesToProducePerDayInBrand: 0,
  mealsCodingVersion: '',
};

export default defaultState;
